export default __webpack_public_path__ + "static/media/IKEA_cyprus.cdc39569.png";